export const INVITE_DRIVER_REQUEST = "INVITE_DRIVER_REQUEST";
export const INVITE_DRIVER_SUCCESS = "INVITE_DRIVER_SUCCESS";
export const INVITE_DRIVER_FAILURE = "INVITE_DRIVER_FAILURE";
export const GET_LIST_DRIVER = "GET_LIST_DRIVER";
export const GET_LIST_DRIVER_REQUEST = "GET_LIST_DRIVER_REQUEST";

export const DELETE_DRIVER_REQUEST = "DELETE_DRIVER_REQUEST";
export const DRIVER_GET_STATE_DATA = "DRIVER_GET_STATE_DATA";
